var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{
    'f-weight-bold': _vm.bold,
    'f-size-xx-small': _vm.xxsmall,
    'f-size-x-small': _vm.xsmall,
    'f-size-small': _vm.small,
    'f-size-medium': _vm.medium,
    'f-size-large': _vm.large,
    'f-family-ja-contract': _vm.jaContract,
    'f-family-en-contract': _vm.enContract,
    wrapping: _vm.wrapping
  },style:({
    color: _vm.color
  }),attrs:{"for":_vm.htmlFor},on:{"click":function($event){return _vm.$emit('click', $event)},"contextmenu":function($event){return _vm.$emit('contextmenu', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b82588","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_atoms/labels/Label.vue
// module id = null
// module chunks = 